export default __webpack_public_path__ + "static/media/categoria_sae.02b8df85.svg";